import { render, staticRenderFns } from "./historicalSupplement.vue?vue&type=template&id=dc8a7ffc&scoped=true&"
import script from "./historicalSupplement.vue?vue&type=script&lang=js&"
export * from "./historicalSupplement.vue?vue&type=script&lang=js&"
import style0 from "./historicalSupplement.vue?vue&type=style&index=0&id=dc8a7ffc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc8a7ffc",
  null
  
)

export default component.exports